import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { createId } from '../utils/createId.js';
import { insertNode, findNode, cloneNode, removeNode, moveNode } from '../utils/node.js';

function createNodeCommand(type, path, props) {
  return {
    exec: function exec(_ref) {
      var setState = _ref.setState,
        components = _ref.components;
      setState(function (state) {
        var _children;
        // Create node inside it
        var child = components[type];
        return _objectSpread2(_objectSpread2({}, state), {}, {
          cursor: path,
          document: insertNode(state.document, path, {
            key: createId(),
            type: type,
            props: _objectSpread2(_objectSpread2(_objectSpread2({}, child.defaultProps ? typeof child.defaultProps === 'function' ? child.defaultProps() : child.defaultProps : {}), props !== null && props !== void 0 ? props : {}), {}, {
              children: null
            }),
            children: (_children = (child.defaultProps ? typeof child.defaultProps === 'function' ? child.defaultProps() : child.defaultProps : {}).children) !== null && _children !== void 0 ? _children : []
          })
        });
      });
    }
  };
}
function cloneNodeCommand(path) {
  return {
    exec: function exec(_ref2) {
      var setState = _ref2.setState;
      setState(function (state) {
        var nextCursor = path.map(function (v, i) {
          return i === path.length - 1 ? v + 1 : v;
        });
        var node = findNode(state.document, path);
        if (node == null) {
          return state;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          cursor: nextCursor,
          document: insertNode(state.document, nextCursor, cloneNode(node))
        });
      });
    }
  };
}
function removeNodeCommand(path) {
  return {
    exec: function exec(_ref3) {
      var setState = _ref3.setState;
      setState(function (state) {
        var prevCursor = path.slice(0, -1);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          cursor: prevCursor,
          document: removeNode(state.document, path)
        });
      });
    }
  };
}
function moveNodeCommand(srcPath, destPath) {
  return {
    exec: function exec(_ref4) {
      var setState = _ref4.setState;
      setState(function (state) {
        return _objectSpread2(_objectSpread2({}, state), moveNode(state.document, srcPath, destPath));
      });
    }
  };
}

export { cloneNodeCommand, createNodeCommand, moveNodeCommand, removeNodeCommand };
//# sourceMappingURL=node.js.map
